import { motion } from 'motion/react';
import { FormError, FormSuccess } from '~/components';

export const FormBox = ({
  label,
  children,
  error,
  success,
}: {
  label?: string;
  children: React.ReactNode;
  error?: string | null | undefined;
  success?: string | null | undefined;
}) => {
  return (
    <div className="space-y-4">
      {label && <div>{label}</div>}

      <div className="rounded-xl border p-5">
        <div className="space-y-6">{children}</div>

        <motion.div
          className="relative"
          initial={{ height: 0 }}
          animate={{ height: error || success ? 55 : 0 }}
        >
          <div className="absolute left-1/2 top-6 -translate-x-1/2">
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={{
                opacity: error || success ? 1 : 0,
                scale: error || success ? 1 : 0,
              }}
            >
              <FormError error={error} />
              <FormSuccess success={success} />
            </motion.div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
